class FacetSortSelect extends HTMLElement {
  connectedCallback() {
    this.control = this.querySelector('.facet-sort__control');
    this.select = this.querySelector('select');
    this.trigger = this.querySelector('.facet-sort__trigger');
    this.valueEl = this.querySelector('.facet-sort__value');
    this.list = this.querySelector('.facet-sort__list');
    this.options = Array.from(this.querySelectorAll('.facet-sort__option'));

    if (!this.select || !this.trigger || !this.list) return;

    this.onTriggerClick = this.toggle.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.trigger.addEventListener('click', this.onTriggerClick);
    this.list.addEventListener('click', this.onOptionClick);
    document.addEventListener('click', this.onDocumentClick);
    this.addEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onTriggerClick);
    this.list?.removeEventListener('click', this.onOptionClick);
    document.removeEventListener('click', this.onDocumentClick);
    this.removeEventListener('keydown', this.onKeyDown);
  }

  get isOpen() {
    return this.control?.classList.contains('is-open');
  }

  open() {
    this.control.classList.add('is-open');
    this.list.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.control.classList.remove('is-open');
    this.list.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  onDocumentClick(event) {
    if (!this.isOpen) return;
    if (this.contains(event.target)) return;
    this.close();
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      event.preventDefault();
      this.close();
      this.trigger.focus();
    }
  }

  onOptionClick(event) {
    const option = event.target.closest('.facet-sort__option');
    if (!option) return;

    const value = option.dataset.value;
    const label = option.textContent.trim();

    this.select.value = value;
    this.valueEl.textContent = label;

    this.options.forEach((item) => {
      const selected = item === option;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    this.close();
    this.select.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

if (!customElements.get('facet-sort-select')) {
  customElements.define('facet-sort-select', FacetSortSelect);
}
